import * as z from "zod/v4";

export const ProfileEmailSourceSchema = z.enum([
  "CONTEXTUAL",
  "VOLDEMORT",
  "UNSPECIFIED",
]);
export type ProfileEmailSource = z.infer<typeof ProfileEmailSourceSchema>;
